import { PropsWithChildren } from "react";

import login from "@/assets/images/login.png";
import Logo from "@/assets/images/logo.png";
import Toast from "@/components/Toast";
import useLoginCheck from "@/hooks/useLoginCheck";
import useLoginStore from "@/store/loginStore";

const LoginLayout = ({ children }: PropsWithChildren) => {
  const { kakaoToken } = useLoginStore();
  useLoginCheck(kakaoToken);

  return (
    <div className="relative flex min-h-screen w-full items-center justify-center overflow-auto">
      {/* 풀스크린 배경 이미지 */}
      <img
        src={login}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* 어두운 오버레이 + 블러 */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px]" />

      {/* 중앙 카드 */}
      <section className="relative z-10 mx-4 flex w-full max-w-[480px] flex-col items-center rounded-2xl border border-white/20 bg-white/10 px-6 py-10 shadow-2xl backdrop-blur-xl sm:px-10 sm:py-12">
        {/* 로고 */}
        <img src={Logo} alt="SpotOn" className="h-10 object-contain" />

        {/* 로그인 콘텐츠 */}
        <div className="mt-8 w-full [&_h1]:text-white [&_p]:text-white/70 [&_button]:shadow-lg">
          {children}
        </div>
      </section>

      {/* 하단: 성경 구절 + 카피라이트 */}
      <div className="absolute bottom-8 z-10 flex flex-col items-center gap-2 text-center">
        <p className="text-xs italic leading-relaxed text-white/40">
          "하나님의 나라를 전파하며 주 예수 그리스도에 관한 모든 것을 담대하게 거침없이 가르치더라"
        </p>
        <p className="text-[11px] text-white/30">
          사도행전 28:31 &nbsp;·&nbsp; SpotOn - 평택온누리교회 예약 시스템
        </p>
      </div>
      <Toast />
    </div>
  );
};

export default LoginLayout;
